export const cleanDateUpgraded = (strDateUpgraded) => {
    if (!strDateUpgraded || typeof strDateUpgraded !== "string") {
        return null;
    }

    try {
        // Match "September 5, 2025"
        const match = strDateUpgraded.match(/^([A-Za-z]+) (\d{1,2}), (\d{4})$/);
        if (!match) return null;

        const [ , monthName, day, year ] = match;

        const months = {
            January: 1, February: 2, March: 3, April: 4, May: 5, June: 6,
            July: 7, August: 8, September: 9, October: 10, November: 11, December: 12
        };

        const month = months[monthName];
        if (!month) return null;

        // Pad month/day to 2 digits
        const mm = String(month).padStart(2, "0");
        const dd = String(day).padStart(2, "0");

        return `${year}-${mm}-${dd}`;
    } catch {
        return null;
    }
};
